var _defs, _g, _g2, _g3, _path, _path2, _path3, _g4, _g5, _g6, _g7, _g8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlantafel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 565,
    zoomAndPan: "magnify",
    viewBox: "0 0 423.75 538.499984",
    height: 718,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "44b33e5710"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.0703125 0 L 423.429688 0 L 423.429688 538 L 0.0703125 538 Z M 0.0703125 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a24ec58859"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.0703125 0 L 423.082031 0 L 423.082031 537.460938 L 0.0703125 537.460938 Z M 0.0703125 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "71bb798907"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 154.160156 286.992188 L 268.800781 286.992188 L 268.800781 401.636719 L 154.160156 401.636719 Z M 154.160156 286.992188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e5da47443e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 158.796875 311.152344 L 181.292969 311.152344 L 181.292969 320.5 L 158.796875 320.5 Z M 158.796875 311.152344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "43c52c915b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 163.472656 311.152344 L 176.613281 311.152344 C 179.195312 311.152344 181.289062 313.242188 181.289062 315.824219 C 181.289062 318.40625 179.195312 320.5 176.613281 320.5 L 163.472656 320.5 C 160.890625 320.5 158.796875 318.40625 158.796875 315.824219 C 158.796875 313.242188 160.890625 311.152344 163.472656 311.152344 Z M 163.472656 311.152344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c184ff3ed7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 186.71875 326.195312 L 209.214844 326.195312 L 209.214844 335.546875 L 186.71875 335.546875 Z M 186.71875 326.195312 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "970d0044cd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 191.394531 326.195312 L 204.535156 326.195312 C 207.117188 326.195312 209.210938 328.289062 209.210938 330.871094 C 209.210938 333.453125 207.117188 335.546875 204.535156 335.546875 L 191.394531 335.546875 C 188.8125 335.546875 186.71875 333.453125 186.71875 330.871094 C 186.71875 328.289062 188.8125 326.195312 191.394531 326.195312 Z M 191.394531 326.195312 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "843cf5ad4b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 213.824219 357.140625 L 236.320312 357.140625 L 236.320312 366.488281 L 213.824219 366.488281 Z M 213.824219 357.140625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "95479a7261"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 218.5 357.140625 L 231.640625 357.140625 C 234.222656 357.140625 236.316406 359.234375 236.316406 361.816406 C 236.316406 364.398438 234.222656 366.488281 231.640625 366.488281 L 218.5 366.488281 C 215.917969 366.488281 213.824219 364.398438 213.824219 361.816406 C 213.824219 359.234375 215.917969 357.140625 218.5 357.140625 Z M 218.5 357.140625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f0daa587a7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 240.8125 372.242188 L 263.304688 372.242188 L 263.304688 381.589844 L 240.8125 381.589844 Z M 240.8125 372.242188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ea7572f139"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 245.484375 372.242188 L 258.628906 372.242188 C 261.207031 372.242188 263.300781 374.335938 263.300781 376.917969 C 263.300781 379.5 261.207031 381.589844 258.628906 381.589844 L 245.484375 381.589844 C 242.902344 381.589844 240.8125 379.5 240.8125 376.917969 C 240.8125 374.335938 242.902344 372.242188 245.484375 372.242188 Z M 245.484375 372.242188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "876f082c90"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 240.8125 311.152344 L 263.304688 311.152344 L 263.304688 320.5 L 240.8125 320.5 Z M 240.8125 311.152344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6eca455824"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 245.484375 311.152344 L 258.628906 311.152344 C 261.207031 311.152344 263.300781 313.242188 263.300781 315.824219 C 263.300781 318.40625 261.207031 320.5 258.628906 320.5 L 245.484375 320.5 C 242.902344 320.5 240.8125 318.40625 240.8125 315.824219 C 240.8125 313.242188 242.902344 311.152344 245.484375 311.152344 Z M 245.484375 311.152344 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#44b33e5710)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0.0703125 0 L 423.429688 0 L 423.429688 538 L 0.0703125 538 Z M 0.0703125 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a24ec58859)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0.0703125 0 L 423.082031 0 L 423.082031 537.027344 L 0.0703125 537.027344 Z M 0.0703125 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#71bb798907)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0cc0df",
    d: "M 265.160156 392.253906 C 265.160156 395.425781 262.589844 397.996094 259.421875 397.996094 L 240.28125 397.996094 L 240.28125 386.511719 L 265.160156 386.511719 Z M 157.984375 392.253906 L 157.984375 386.511719 L 182.867188 386.511719 L 182.867188 397.996094 L 163.726562 397.996094 C 160.558594 397.996094 157.984375 395.425781 157.984375 392.253906 Z M 157.984375 296.5625 C 157.984375 293.390625 160.558594 290.820312 163.726562 290.820312 L 259.421875 290.820312 C 262.589844 290.820312 265.160156 293.390625 265.160156 296.5625 L 265.160156 306.132812 L 157.984375 306.132812 Z M 240.28125 371.203125 L 265.160156 371.203125 L 265.160156 382.683594 L 240.28125 382.683594 Z M 213.488281 382.683594 L 213.488281 371.203125 L 236.453125 371.203125 L 236.453125 382.683594 Z M 213.488281 386.511719 L 236.453125 386.511719 L 236.453125 397.996094 L 213.488281 397.996094 Z M 209.660156 386.511719 L 209.660156 397.996094 L 186.695312 397.996094 L 186.695312 386.511719 Z M 186.695312 371.203125 L 209.660156 371.203125 L 209.660156 382.683594 L 186.695312 382.683594 Z M 157.984375 371.203125 L 182.867188 371.203125 L 182.867188 382.683594 L 157.984375 382.683594 Z M 182.867188 321.441406 L 157.984375 321.441406 L 157.984375 309.957031 L 182.867188 309.957031 Z M 213.488281 355.890625 L 236.453125 355.890625 L 236.453125 367.375 L 213.488281 367.375 Z M 186.695312 355.890625 L 209.660156 355.890625 L 209.660156 367.375 L 186.695312 367.375 Z M 209.660156 336.753906 L 186.695312 336.753906 L 186.695312 325.269531 L 209.660156 325.269531 Z M 213.488281 336.753906 L 213.488281 325.269531 L 236.453125 325.269531 L 236.453125 336.753906 Z M 209.660156 352.0625 L 186.695312 352.0625 L 186.695312 340.582031 L 209.660156 340.582031 Z M 213.488281 340.582031 L 236.453125 340.582031 L 236.453125 352.0625 L 213.488281 352.0625 Z M 157.984375 325.269531 L 182.867188 325.269531 L 182.867188 336.753906 L 157.984375 336.753906 Z M 157.984375 340.582031 L 182.867188 340.582031 L 182.867188 352.0625 L 157.984375 352.0625 Z M 157.984375 355.890625 L 182.867188 355.890625 L 182.867188 367.375 L 157.984375 367.375 Z M 265.160156 367.375 L 240.28125 367.375 L 240.28125 355.890625 L 265.160156 355.890625 Z M 265.160156 352.0625 L 240.28125 352.0625 L 240.28125 340.582031 L 265.160156 340.582031 Z M 265.160156 336.753906 L 240.28125 336.753906 L 240.28125 325.269531 L 265.160156 325.269531 Z M 265.160156 309.957031 L 265.160156 321.441406 L 240.28125 321.441406 L 240.28125 309.957031 Z M 236.453125 309.957031 L 236.453125 321.441406 L 213.488281 321.441406 L 213.488281 309.957031 Z M 209.660156 309.957031 L 209.660156 321.441406 L 186.695312 321.441406 L 186.695312 309.957031 Z M 259.421875 286.992188 L 163.726562 286.992188 C 158.449219 286.992188 154.160156 291.285156 154.160156 296.5625 L 154.160156 392.253906 C 154.160156 397.53125 158.449219 401.824219 163.726562 401.824219 L 259.421875 401.824219 C 264.699219 401.824219 268.988281 397.53125 268.988281 392.253906 L 268.988281 296.5625 C 268.988281 291.285156 264.699219 286.992188 259.421875 286.992188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0cc0df",
    d: "M 171.382812 296.5625 L 163.726562 296.5625 C 162.671875 296.5625 161.8125 297.421875 161.8125 298.476562 C 161.8125 299.53125 162.671875 300.390625 163.726562 300.390625 L 171.382812 300.390625 C 172.4375 300.390625 173.296875 299.53125 173.296875 298.476562 C 173.296875 297.421875 172.4375 296.5625 171.382812 296.5625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0cc0df",
    d: "M 188.609375 298.476562 C 188.609375 297.421875 187.746094 296.5625 186.695312 296.5625 L 179.039062 296.5625 C 177.984375 296.5625 177.125 297.421875 177.125 298.476562 C 177.125 299.53125 177.984375 300.390625 179.039062 300.390625 L 186.695312 300.390625 C 187.746094 300.390625 188.609375 299.53125 188.609375 298.476562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0cc0df",
    d: "M 194.347656 300.390625 L 202.003906 300.390625 C 203.058594 300.390625 203.917969 299.53125 203.917969 298.476562 C 203.917969 297.421875 203.058594 296.5625 202.003906 296.5625 L 194.347656 296.5625 C 193.296875 296.5625 192.433594 297.421875 192.433594 298.476562 C 192.433594 299.53125 193.296875 300.390625 194.347656 300.390625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e5da47443e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#43c52c915b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 158.796875 311.152344 L 181.292969 311.152344 L 181.292969 320.5 L 158.796875 320.5 Z M 158.796875 311.152344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c184ff3ed7)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#970d0044cd)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 186.71875 326.195312 L 209.214844 326.195312 L 209.214844 335.546875 L 186.71875 335.546875 Z M 186.71875 326.195312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#843cf5ad4b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#95479a7261)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 213.824219 357.140625 L 236.320312 357.140625 L 236.320312 366.488281 L 213.824219 366.488281 Z M 213.824219 357.140625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f0daa587a7)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ea7572f139)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 240.8125 372.242188 L 263.304688 372.242188 L 263.304688 381.589844 L 240.8125 381.589844 Z M 240.8125 372.242188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#876f082c90)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6eca455824)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 240.8125 311.152344 L 263.304688 311.152344 L 263.304688 320.5 L 240.8125 320.5 Z M 240.8125 311.152344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlantafel);
export default __webpack_public_path__ + "static/media/Plantafel.da07841ea6eb67ebdb61801a94982051.svg";
export { ForwardRef as ReactComponent };